export const environment = {
  production: true,
  appVersion: require('../../package.json').version,
  apiURL: 'https://siteapi.fre.com.br/'
};
